import React from 'react';
import styles from './LeagueList.module.scss';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { Box, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useSelector } from 'react-redux';
const LeagueList = ({ editLeague, onSubAdd, onAdd, onEdit, onSubEdit }) => {
  const {
    leagueList: { data: leagueListData, loading: leagueListDataLoading },
  } = useSelector((state) => state.app);
  return (
    <Box>
      <TreeView
        selected={null}
        multiSelect={false}
        aria-label="file system navigator"
        defaultExpanded={leagueListData?.leagues?.map((league) => league?.id)}
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpandIcon={<ChevronRightIcon />}
        sx={{
          '& .Mui-selected': { backgroundColor: 'transparent' },
          flexGrow: 1,
          maxWidth: 400,
          overflowY: 'auto',
        }}>
        {leagueListData?.leagues?.map((league) => (
          <TreeItem
            key={league?.id}
            className={editLeague?.id == league?.id ? 'tree-expand' : ''}
            onClick={() => {
              onEdit(league);
            }}
            nodeId={league?.id}
            label={
              <>
                <Box sx={{ display: 'grid', alignItems: 'center', gap: 1, gridTemplateColumns: '24px 1fr' }}>
                  <Box component={'img'} src={league?.logo} sx={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '50%', margin: '0 auto' }}></Box>
                  <Box>{league?.name}</Box>
                </Box>
              </>
            }
            sx={{
              '& .MuiTreeItem-content': {
                height: '40px',
              },
            }}>
            {league?.children?.map((subleage) => (
              <TreeItem
                key={subleage?.id}
                className={editLeague?.id == subleage?.id ? 'tree-expand' : ''}
                onClick={() => {
                  onSubEdit({ ...subleage, parent: league });
                }}
                nodeId={subleage?.id}
                label={
                  <>
                    <Box sx={{ display: 'grid', alignItems: 'center', gap: 1, gridTemplateColumns: '24px 1fr' }}>
                      <Box component={'img'} src={subleage?.logo} sx={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '50%', margin: '0 auto' }}></Box>
                      <Box>{subleage?.name}</Box>
                    </Box>
                  </>
                }
                sx={{
                  '& .MuiTreeItem-content': {
                    height: '40px',
                  },
                }}></TreeItem>
            ))}
            <Button
              onClick={() => {
                onSubAdd(league);
              }}
              size="small"
              variant="outlined"
              sx={{ mt: 1, mb: 1, width: 'calc(100% - 32px)', ml: 'auto', display: 'flex', height: '40px' }}>
              Добавить подлигу
            </Button>
          </TreeItem>
        ))}
      </TreeView>

      <Button onClick={onAdd} variant="outlined" size={'large'} sx={{ mt: 6, width: '100%', display: 'flex' }}>
        Добавить лигу
      </Button>
    </Box>
  );
};

export default LeagueList;
